import { HatchName } from "./hatch-list";

import ANGLE from "@/assets/patterns/ANGLE.png";
import ANSI31 from "@/assets/patterns/ANSI31.png";
import ANSI32 from "@/assets/patterns/ANSI32.png";
import ANSI33 from "@/assets/patterns/ANSI33.png";
import ANSI34 from "@/assets/patterns/ANSI34.png";
import ANSI36 from "@/assets/patterns/ANSI36.png";
import ANSI37 from "@/assets/patterns/ANSI37.png";
import ANSI38 from "@/assets/patterns/ANSI38.png";
import AR_B816 from "@/assets/patterns/AR-B816.png";
import AR_B816C from "@/assets/patterns/AR-B816C.png";
import AR_CONC from "@/assets/patterns/AR-CONC.png";
import AR_RROOF from "@/assets/patterns/AR-RROOF.png";
import AR_SAND from "@/assets/patterns/AR-SAND.png";
import AR_RSHKE from "@/assets/patterns/AR-RSHKE.png";
import ASBESTOS from "@/assets/patterns/ASBESTOS.png";
import BRASS from "@/assets/patterns/BRASS.png";
import BOX from "@/assets/patterns/BOX.png";
import CONCRT from "@/assets/patterns/CONCRT.png";
import CORK from "@/assets/patterns/CORK.png";
import CROSS from "@/assets/patterns/CROSS.png";
import DASH from "@/assets/patterns/DASH.png";
import DOTS from "@/assets/patterns/DOTS.png";
import EARTH from "@/assets/patterns/EARTH.png";
import ETOILE_02 from "@/assets/patterns/ETOILE-02.png";
import ETOILE_03 from "@/assets/patterns/ETOILE-03.png";
import ETOILE_05 from "@/assets/patterns/ETOILE-05.png";
import FLEX from "@/assets/patterns/FLEX.png";
import GOST_GLASS from "@/assets/patterns/GOST_GLASS.png";
import GOST_GROUND from "@/assets/patterns/GOST_GROUND.png";
import GOST_WOOD from "@/assets/patterns/GOST_WOOD.png";
import GRASS from "@/assets/patterns/GRASS.png";
import GRATE from "@/assets/patterns/GRATE.png";
import GRAVEL from "@/assets/patterns/GRAVEL.png";
import GRILLE_13 from "@/assets/patterns/GRILLE-13.png";
import GRILLE_16 from "@/assets/patterns/GRILLE-16.png";
import HEX from "@/assets/patterns/HEX.png";
import HONEY from "@/assets/patterns/HONEY.png";
import HOUND from "@/assets/patterns/HOUND.png";
import HUM from "@/assets/patterns/HUM.png";
import INSUL from "@/assets/patterns/INSUL.png";
import JIS_LC_8A from "@/assets/patterns/JIS_LC_8A.png";
import OMBRE_08 from "@/assets/patterns/OMBRE-08.png";
import MUDST from "@/assets/patterns/MUDST.png";
import NET3 from "@/assets/patterns/NET3.png";
import PANEL from "@/assets/patterns/PANEL.png";
import SACNCR from "@/assets/patterns/SACNCR.png";
import SWAMP from "@/assets/patterns/SWAMP.png";
import TEXTURE from "@/assets/patterns/TEXTURE.png";
import TRIANG from "@/assets/patterns/TRIANG.png";
import ZIGZAG from "@/assets/patterns/ZIGZAG.png";
import ANSI32_315_45 from "@/assets/patterns/ANSI32-315-45.png";

export const hatchPatternImg: Record<HatchName, string> = {
  ANGLE,
  ANSI31,
  ANSI32,
  ANSI33,
  ANSI34,
  ANSI36,
  ANSI37,
  ANSI38,
  [HatchName.AR_B816]: AR_B816,
  [HatchName.AR_B816C]: AR_B816C,
  [HatchName.AR_CONC]: AR_CONC,
  [HatchName.AR_RROOF]: AR_RROOF,
  [HatchName.AR_SAND]: AR_SAND,
  [HatchName.AR_RSHKE]: AR_RSHKE,
  ASBESTOS,
  BRASS,
  BOX,
  CONCRT,
  CORK,
  CROSS,
  DASH,
  DOTS,
  EARTH,
  [HatchName.ETOILE_02]: ETOILE_02,
  [HatchName.ETOILE_03]: ETOILE_03,
  [HatchName.ETOILE_05]: ETOILE_05,
  FLEX,
  GOST_GLASS,
  GOST_GROUND,
  GOST_WOOD,
  GRASS,
  GRATE,
  GRAVEL,
  [HatchName.GRILLE_13]: GRILLE_13,
  [HatchName.GRILLE_16]: GRILLE_16,

  HEX,
  HONEY,
  HOUND,
  HUM,
  INSUL,
  [HatchName.JIS_LC_8A]: JIS_LC_8A,
  [HatchName.OMBRE_08]: OMBRE_08,
  MUDST,
  NET3,
  PANEL,
  SACNCR,
  SWAMP,
  TEXTURE,
  TRIANG,
  ZIGZAG,
  [HatchName.ANSI32_315_45]: ANSI32_315_45,
};
